export const favouritesBaseApiUrl = process.env.REACT_APP_API_URL ?? "/api";
